import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGrid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 9.5V14.5H1.5V9.5H6.5ZM14.5 9.5V14.5H9.5V9.5H14.5ZM6.5 1.5V6.5H1.5V1.5H6.5ZM14.5 1.5V6.5H9.5V1.5H14.5Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinejoin: "round"
	})
});
export default SvgGrid;
